import FormControl from "common/components/FormControl/FormControl";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import CrudForm from "common/components/Crud/CrudForm";
import type { Plan } from "types";

type Props = {
  onSubmit: (values: any) => any;
  onCancel?: () => void;
  item?: Plan;
};

function PlanForm({ onSubmit, onCancel, item }: Props) {
  const { t } = useTranslation();

  const initialValues = useMemo(
    () =>
      item?.id
        ? {
            ...item,
          }
        : {},
    [item],
  );

  return (
    <CrudForm
      onSubmit={onSubmit}
      onCancel={onCancel}
      initialValues={initialValues}
      headerIcon="TbGauge"
      i18nNamespace="plans"
      render={() => (
        <div className="white-box flex flex-col gap-2">
          <FormControl name="name" title={t("plans.name")} required />
          <FormControl name="value" title={t("plans.value")} required />
        </div>
      )}
    />
  );
}

export default PlanForm;
